import { type OptionType } from '@hivebrite/design-system/Inputs';

import { type GetTopicItem } from 'hb-react/shared/components/ReactSelect/ReactSelectTopics/requests';

export const topicsToOptions = (
  topics: Array<GetTopicItem>,
): Array<OptionType> =>
  topics.map(({ id, name, accessibleByCurrentAdmin }) => ({
    value: id,
    label: name,
    isFixed:
      accessibleByCurrentAdmin === undefined
        ? false
        : !accessibleByCurrentAdmin,
  }));
